import { Component, computed, inject, input, output } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { Announcement, AnnouncementMessages } from '@insolution/graphql-data-access';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';

@Component({
  selector: 'lib-announcement-banner',
  imports: [],
  templateUrl: './announcement-banner.html',
  styleUrl: './announcement-banner.scss',
})
export class AnnouncementBanner {
  public announcements = input.required<Announcement[]>();
  public closeAnnouncement = output<string>();

  private translateService = inject(TranslateService);

  private currentLanguage = toSignal(
    this.translateService.onLangChange.pipe(
      takeUntilDestroyed(),
      map((event) => event.lang)
    ),
    { initialValue: this.translateService.getCurrentLang() }
  );

  protected localizedAnnouncements = computed(() =>
    this.announcements().map((announcement) => ({
      id: announcement.id,
      message: this.messageForCurrentLanguage(announcement.messages),
    }))
  );

  protected onClose(id: string): void {
    this.closeAnnouncement.emit(id);
  }

  private messageForCurrentLanguage(messages: AnnouncementMessages): string {
    const messageKey = (this.currentLanguage() ?? 'en-US').replace('-', '_') as keyof AnnouncementMessages;

    return messages[messageKey] ?? messages.en_US;
  }
}
